import Store from 'repatch';
import State from '../core/State';
import { clearSnackbar, setSnackbar } from '../thunk/snackbar';

type NotifyOptions = {
  messageValues?: Record<string, any> | null;
  action?: string | null;
  severity?: 'default' | 'error' | 'warning' | 'information' | 'success';
  actionValues?: Record<string, any> | null;
  isRaw?: boolean;
  onClickAction?: (() => void) | null;
};

class MessageDispatcher {
  private readonly store: Store<State>;

  constructor({ store }: { store: Store<State> }) {
    this.store = store;
  }

  public notifyUnimportant = (
    message: string,
    {
      messageValues = null,
      severity = 'default',
      action = null,
      actionValues = null,
      isRaw = false,
      onClickAction = null,
    }: NotifyOptions = {},
  ) => {
    this.store.dispatch(
      setSnackbar({
        message,
        messageValues: messageValues,
        action: action,
        severity,
        actionValues: actionValues,
        isRaw,
        onClickAction,
      }),
    );
  };

  public clearUnimportant = () => {
    this.store.dispatch(clearSnackbar());
  };
}

export default MessageDispatcher;
